import React from "react";
import { motion } from "framer-motion";
import { Building2, UserRoundCheck, FlaskConical, Users } from "lucide-react";

const CLIENTS = [
  {
    icon: Building2,
    title: "Corporativos y Empresas del Sector Privado",
    text: "Organizaciones que buscan elevar su competitividad, optimizar sus canales de venta o externalizar procesos logísticos, y que desean cumplir con altos estándares de responsabilidad social e inclusión laboral.",
  },
  {
    icon: UserRoundCheck,
    title: "Talento en Búsqueda de Oportunidades",
    text: "Personas desempleadas, subempleadas o en situación de discapacidad que requieren orientación social estratégica y capacitación técnica adaptada para integrarse con éxito al mercado laboral.",
  },
  {
    icon: FlaskConical,
    title: "Instituciones y Organismos de Investigación",
    text: "Entidades que demandan análisis de mercado rigurosos, encuestas de opinión pública y proyectos de desarrollo científico fundamentados sólidamente en las ciencias sociales y las humanidades.",
  },
  {
    icon: Users,
    title: "Líderes de Recursos Humanos y Operaciones",
    text: "Directivos que necesitan programas especializados en gestión del cambio organizacional, auditorías de procesos y estrategias efectivas para la retención de talento diverso.",
  },
];

export const Clients = () => {
  return (
    <section
      id="publico-clientes"
      data-testid="clients-section"
      className="py-24 lg:py-32 bg-white relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -top-32 -left-32 w-[500px] h-[500px] rounded-full bg-[#72B3E4]/10 blur-3xl -z-0"
      />
      <div className="container-page relative">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-7">
            <p className="text-xs uppercase tracking-[0.25em] text-[#055794] font-semibold mb-5">
              Público y clientes
            </p>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#022140] tracking-tight leading-[1.05] text-balance">
              Público y clientes de nuestra organización.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 flex items-end">
            <p className="text-[17px] text-[#7F7F7F] leading-relaxed">
              Atendemos a cuatro grupos estratégicos, cada uno con necesidades
              específicas que abordamos con metodologías probadas y resultados
              medibles.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-5 lg:gap-6">
          {CLIENTS.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.article
                key={c.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.55, delay: i * 0.07 }}
                data-testid={`client-card-${i}`}
                className="group relative overflow-hidden rounded-3xl border border-slate-200 bg-white p-8 lg:p-10 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(2,33,64,0.25)] hover:border-[#72B3E4]"
              >
                <div className="absolute top-0 right-0 w-40 h-40 bg-[#72B3E4]/0 group-hover:bg-[#72B3E4]/10 rounded-full blur-2xl transition-all duration-500 -mr-12 -mt-12" />
                <div className="relative flex items-start gap-5">
                  <div className="flex-shrink-0">
                    <div className="inline-flex items-center justify-center h-14 w-14 rounded-2xl bg-[#022140] text-[#72B3E4] group-hover:bg-[#055794] group-hover:text-white transition-colors">
                      <Icon size={24} />
                    </div>
                    <div className="mt-4 flex items-center gap-2 text-[#055794] text-xs font-medium uppercase tracking-[0.18em]">
                      <span className="h-px w-6 bg-[#055794]" />
                      <span>0{i + 1}</span>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-heading text-xl lg:text-2xl font-bold text-[#022140] mb-3 leading-tight">
                      {c.title}
                    </h3>
                    <p className="text-[15px] text-[#7F7F7F] leading-relaxed">
                      {c.text}
                    </p>
                  </div>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
